import { render, staticRenderFns } from "./MbAudio.vue?vue&type=template&id=fcb0fcb0&scoped=true&"
import script from "./MbAudio.vue?vue&type=script&lang=js&"
export * from "./MbAudio.vue?vue&type=script&lang=js&"
import style0 from "./MbAudio.vue?vue&type=style&index=0&id=fcb0fcb0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb0fcb0",
  null
  
)

export default component.exports